import { render, staticRenderFns } from "./PurchasesOrderViewDeliveryState.vue?vue&type=template&id=02f939e4&scoped=true"
import script from "./PurchasesOrderViewDeliveryState.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDeliveryState.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewDeliveryState.vue?vue&type=style&index=0&id=02f939e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f939e4",
  null
  
)

export default component.exports